import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { jobsRoute, profilesRoute } from '../../routes/index';
import { formatNumber, DateFormatter } from '../../utils/date';
import {Link} from 'react-router';
import forEach from 'lodash/forEach';
import Image from '../../components/image/image';
import { fetchProfiles } from '../../actions/profiles';
import { fetchJobs } from '../../actions/jobs';
import connect from '../../utils/connect';
import Spinner from '../../components/svg/spinner';
import Tooltip from '../../components/tooltip/tooltip';
import translate from '../../utils/translate';

class ContextualProfiles extends Component {
	static propTypes = {};

	constructor(props) {
		super(props);

		this.state = {
			searchWord: '',
			searchResults: [],
			searched: false,
			busy: false,
			clearProfiles: false,
			active: false,
		};

		this.busy = false;
		this.profiles = [];
		this.firstLaunch = true;
	}

	componentWillMount() {

		if (this.props.enableProfiles) {
			this.fetchProfiles = bindActionCreators(fetchProfiles, this.props.dispatch);
			this.fetchProfiles();
		}
	}

	componentWillUnmount() {
		document.querySelector('body').classList.remove('context-active');
	}

	componentDidMount() {

	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.enableProfiles !== this.props.enableProfiles) {
			this.fetchProfiles();
		}
	}

	componentWillUpdate(nextProps) {
		this.state.searched = false;
		if (this.props.enableProfiles) {
			if (this.profiles.length <= 1 || !this.props.profiles.profiles || this.state.clearProfiles) {
				let _this = this;
				this.profiles = [];

				forEach(nextProps.profiles.profiles, function(profile) {
					_this.profiles.push(profile);
				});

				this.state.clearProfiles = false;
			} else if (this.props.enableProfiles && nextProps.profiles.profiles && nextProps.profiles.profiles[0].id !== this.props.profiles.profiles[0].id) {
				let _this = this;

				forEach(nextProps.profiles.profiles, function(profile) {
					_this.profiles.push(profile);
				});
			}
		}
	}

	componentDidUpdate() {
		if (this.props.enableProfiles && this.refs.profilesHolder) {
			this.busy = false;

			this.profileHeight = document.querySelector('.contextual-menu__inner-list__profiles__profile').offsetHeight;

			this.visibleProfiles = parseInt(this.refs.profilesHolder.offsetHeight / this.profileHeight);

			let start = parseInt(this.refs.profilesHolder.scrollTop / this.profileHeight) || 0;

			start += 1;

			let finish = parseInt(start + this.visibleProfiles) - 1 || 0;

			let className = '.contextual-menu__inner-list__profiles__profile:nth-child(n+' + start + '):nth-child(-n+' + (finish + 1) + '):not(.contextual-menu__inner-list__profiles__profile--active)';

			let actives = document.querySelectorAll(className);

			forEach(actives, function(single) {
				single.classList.add('contextual-menu__inner-list__profiles__profile--active');
			});
		}

		if (this.state.active && this.refs.search && this.firstLaunch && this.props.browser.window.width > 1030) {
			this.refs.search.focus();
			this.firstLaunch = false;
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextState !== this.state ||
			nextProps !== this.props
		);

		// update on init
		// if ((!this.props.items.length && nextProps.items.length)) {
		// 	return true;
		// }
	}

	render() {
		let profiles = null;
		let total = null;

		if (this.props.profiles) {
			profiles = this.props.profiles.profiles;
		}

		let nextClass = 'span2 span4-mobile contextual-menu__next';
		let prevClass = 'span2 span4-mobile contextual-menu__prev';
		let toggleClass = 'span2-plus span6-tablet-plus span6-mobile-plus contextual-menu__toggle';
		let buttonClass = 'contextual-menu__toggle__button';
		let innerClass = 'contextual-menu__inner span14';
		let controlClass = 'contextual-menu__control span14';

		if (this.state.active) {
			nextClass = 'span2-plus span4-mobile contextual-menu__next contextual-menu__next--active';
			prevClass = 'span2 span4-mobile contextual-menu__prev contextual-menu__prev--active';
			toggleClass += ' contextual-menu__toggle--active';
			buttonClass += ' contextual-menu__toggle__button--active';
			innerClass += ' contextual-menu__inner--active';
			controlClass += ' contextual-menu__control--active';
		}

		if (this.props.seen || this.state.active) {
			controlClass += ' contextual-menu__control--seen'
		}

		return (
			<section className='contextual-menu span14'>
				<div className={controlClass}>
					<div className='contextual-menu__control__top'>
						{this.props.enableProfiles && this.props.prevProfile && (
							<Link onClick={(event) => this.onLinkClick(event)} to={profilesRoute(this.props.prevProfile)}>
							<div className={prevClass}>
								<span className='contextual-menu__arrow contextual-menu__arrow--prev'></span>
							</div>
							</Link>
						) || (
							<div className={prevClass}>
								<span className='contextual-menu__arrow contextual-menu__arrow--prev'></span>
							</div>
						)}
						<div className='span4 span2-tablet hide-mobile contextual-menu__filler'></div>
						<div className={toggleClass}>
							<button ref='contextualToggle' className={buttonClass} onClick={(event) => this.onClick(event)}>
								<div className='burger-icon'>
									<span><i></i></span>
									<span><i></i></span>
									<span><i></i></span>
								</div>
								<div className='close-icon'>
									<span><i></i></span>
									<span><i></i></span>
								</div>
							</button>
						</div>
						<div className='span4 span2-tablet hide-mobile contextual-menu__filler'></div>
						{this.props.enableProfiles && this.props.nextProfile && (
						<Link onClick={(event) => this.onLinkClick(event)} to={profilesRoute(this.props.nextProfile)}>
							<div className={nextClass}>
								<span className='contextual-menu__arrow contextual-menu__arrow--next'></span>
							</div>
						</Link>
						) || (
							<div className={nextClass}>
								<span className='contextual-menu__arrow contextual-menu__arrow--next'></span>
							</div>
						)}
					</div>
					{!this.props.seen && (
					<span className='contextual-menu__control__text'>Discover more</span>
					)}
				</div>
				<div ref='contextualInner' className={innerClass}>
				{this.props.profiles && !!this.props.profiles.profiles.length && this.props.enableProfiles && (
					this.renderProfiles(this.profiles)
				) || (this.props.profiles.error || !!this.props.profiles.profiles.error) && this.props.enableProfiles && (
					this.renderProfiles(this.props.profiles.profiles)
				) || null}
				</div>
			</section>
		);
	}

	profilesScroll(e) {
		if (!this.busy) {
			let last = e.target.lastChild;

			if (e.target.scrollTop - last.offsetHeight > -2000) {
				this.profilesFetch(e.target.getAttribute('data-href'));
				this.busy = true;
			}
		}

		//this.refs.contextualHead.style.transform = 'translatey(' + (e.target.scrollTop - 52) + 'px)';

		let start = parseInt(e.target.scrollTop / this.profileHeight);

		start += 1;

		let finish = parseInt(start + this.visibleProfiles) - 1;

		let target = document.querySelector('.contextual-menu__inner-list__right__title');

		target.innerHTML = start + ' — ' + finish;

		let className = '.contextual-menu__inner-list__profiles__profile:nth-child(n+' + start + '):nth-child(-n+' + (finish + 1) + '):not(.contextual-menu__inner-list__profiles__profile--active)';

		let actives = document.querySelectorAll(className);

		if (!!actives.length) {
			forEach(actives, function(single) {
				single.classList.add('contextual-menu__inner-list__profiles__profile--active');
			});
		}
	}

	renderProfiles(profiles) {
		let uid = 'contextProfiles';
		let offset = 0;

		let spinnerClass = 'contextual-menu__inner-list__profiles__table__spinner';

		if (this.state.searched) {
			spinnerClass = 'contextual-menu__inner-list__profiles__table__spinner profile-list__table__spinner--active';
		}

		let rightClass = 'span2-plus contextual-menu__inner-list__right contextual-menu__inner-list__right--profile hide-mobile';
		let profilesClass = 'contextual-menu__inner-list__profiles span12 span14-mobile';

		if (this.props.seen || this.state.active) {
			rightClass += ' contextual-menu__inner-list__right--seen';
			profilesClass += ' contextual-menu__inner-list__profiles--seen'
		}

		if (this.props.profiles.next) {
			let parameters = this.props.profiles.next;
			parameters = parameters.split('/');
			parameters = parameters[parameters.length - 1];

			parameters = parameters.split('&');

			offset = parameters[0].split('=')[1];

		};

		if (!this.props.profiles.next && this.props.profiles.prev) {
			let parameters = this.props.profiles.prev;
			parameters = parameters.split('/');
			parameters = parameters[parameters.length - 1];

			parameters = parameters.split('&');

			offset = parameters[0].split('=')[1];
		}

		return (
			<article key={uid} className='contextual-menu__inner-list span14'>
				<div className='contextual-menu__inner-list__top span14'>
					<h1 className='contextual-menu__inner-list__top__title'>Profiles</h1>
					<span className='contextual-menu__inner-list__top__number'> ({this.props.profiles.totalProfiles})</span>
				</div>
				<input ref='search' onChange={(event)=>this.onProfileSearch(event)} className='contextual-menu__inner-list__search span12 hide-mobile' type='text' placeholder={translate('contextual/profilesSearch')} />
				<div className='contextual-menu__inner-list__profiles__wrap'>
					<div ref='profilesHolder' className={profilesClass} onScroll={(event) => this.profilesScroll(event)} data-href={this.props.profiles.next}>
						<div ref='contextualHead' className='contextual-menu__inner-list__profiles__table__head span12 span14-mobile'>
							<div className='contextual-menu__inner-list__profiles__table__head__title span1 hide-tablet hide-mobile'></div>
							<div className='contextual-menu__inner-list__profiles__table__head__title contextual-menu__inner-list__profiles__table__head__title--left span3-tablet span4 span10-mobile'>Name</div>
							<div data-sort='total' onClick={(event) => this.sortClick(event)} className='contextual-menu__inner-list__profiles__table__head__title contextual-menu__inner-list__profiles__table__head__title--total contextual-menu__inner-list__profiles__table__head__title--sort '>
								<span className='hide-mobile'>Total</span>
								<span className='hide-tablet hide-desktop'>Awards</span>
							</div>
							<div data-sort='FOTD' onClick={(event) => this.sortClick(event)} className='contextual-menu__inner-list__profiles__table__head__title hide-mobile'>
								<span ref='FOTD'>FOTD</span>
								<Tooltip attachTo={() => this.refs.FOTD}>
									<header>description:</header>
									<h2>{translate('awards/fotd/title')}</h2>
									{translate('awards/fotd/text')}
								</Tooltip>
							</div>
							<div data-sort='TCEA' onClick={(event) => this.sortClick(event)} className='contextual-menu__inner-list__profiles__table__head__title hide-mobile'>
								<span ref='TCEA'>TCEA</span>
								<Tooltip attachTo={() => this.refs.TCEA}>
									<header>description:</header>
									<h2>{translate('awards/tcea/title')}</h2>
									{translate('awards/tcea/text')}
								</Tooltip>
							</div>
							<div data-sort='FOTM' onClick={(event) => this.sortClick(event)} className='contextual-menu__inner-list__profiles__table__head__title hide-mobile'>
								<span ref='FOTM'>FOTM</span>
								<Tooltip attachTo={() => this.refs.FOTM}>
									<header>description:</header>
									<h2>{translate('awards/fotm/title')}</h2>
									{translate('awards/fotm/text')}
								</Tooltip>
							</div>
							<div data-sort='FOTY' onClick={(event) => this.sortClick(event)} className='contextual-menu__inner-list__profiles__table__head__title hide-mobile'>
								<span ref='FOTY'>FOTY</span>
								<Tooltip attachTo={() => this.refs.FOTY}>
									<header>description:</header>
									<h2>{translate('awards/foty/title')}</h2>
									{translate('awards/foty/text')}
								</Tooltip>
							</div>
							<div data-sort='TCEAY' onClick={(event) => this.sortClick(event)} className='contextual-menu__inner-list__profiles__table__head__title hide-mobile'>
								<span ref='TCEAY'>TCEAY</span>
								<Tooltip attachTo={() => this.refs.TCEAY}>
									<header>description:</header>
									<h2>{translate('awards/tceay/title')}</h2>
									{translate('awards/tceay/text')}
								</Tooltip>
							</div>
							<div data-sort='PCA' onClick={(event) => this.sortClick(event)} className='contextual-menu__inner-list__profiles__table__head__title hide-mobile'>
								<span ref='PCA'>PCA</span>
								<Tooltip attachTo={() => this.refs.PCA}>
									<header>description:</header>
									<h2>{translate('awards/pca/title')}</h2>
									{translate('awards/pca/text')}
								</Tooltip>
							</div>
							<div data-sort='MOTD' onClick={(event) => this.sortClick(event)} className='contextual-menu__inner-list__profiles__table__head__title hide-mobile contextual-menu__inner-list__profiles__table__head__title--no-border'>
								<span ref='MOTD'>MOTD</span>
								<Tooltip attachTo={() => this.refs.MOTD}>
									<header>description:</header>
									<h2>{translate('awards/motd/title')}</h2>
									{translate('awards/motd/text')}
								</Tooltip>
							</div>
						</div>
						<ul className='contextual-menu__inner-list__profiles__table span12 span14-mobile'>
							<li ref='profileSpinner' className={spinnerClass}>
								<Spinner pathStroke='#fff' className='profile-list__table__spinner__spinner' size='80px'></Spinner>
							</li>
							{profiles.length && (
								profiles.map((profile, i) => this.renderProfile(profile, i))
							) || profiles.error && (
								<li className='contextual-menu__inner-list__profiles__profile'>
									{profiles.error.title}
									<span className='profile-list__profile__name profile-list__profile__name__weak'>{profiles.error.message}</span>
								</li>
							)}
						</ul>
					</div>
				</div>
				<div className={rightClass}>
					<span className='contextual-menu__inner-list__right__byline'>showing</span>
					<h2 className='contextual-menu__inner-list__right__title'>{1 + ' — ' + 13}</h2>
					<span className='contextual-menu__inner-list__right__number'>{this.props.profiles.total + ' in total'}</span>
					<nav className='contextual-menu__inner-list__right__nav'>
						{this.props.profiles.prev && (
						<a href={this.props.profiles.prev} onClick={(event) => this.profilesPrev(event)} className='contextual-menu__inner-list__right__nav__prev'><span className='contextual-menu__inner-list__right__nav__arrow'></span></a>
						) || (
						<span className='contextual-menu__inner-list__right__nav__prev'><span className='contextual-menu__inner-list__right__nav__arrow contextual-menu__inner-list__right__nav__arrow--inactive'></span></span>
						)}
						{this.props.profiles.next && (
						<a href={this.props.profiles.next} onClick={(event) => this.profilesNav(event)} className='contextual-menu__inner-list__right__nav__next'><span className='contextual-menu__inner-list__right__nav__arrow'></span></a>
						) || (
						<span className='contextual-menu__inner-list__right__nav__next'><span className='contextual-menu__inner-list__right__nav__arrow contextual-menu__inner-list__right__nav__arrow--inactive'></span></span>
						)}
					</nav>
				</div>
			</article>
		);
	}

	renderProfile(profile, i) {
		let uid = 'contextualProfile' + i;

		let url = profilesRoute(profile.slug);

		let offices = '';

		if (profile.offices.length) {
			for (var i = 0; i < profile.offices.length; i++) {
				if (i < profile.offices.length - 1) {
					offices += profile.offices[i].name + ', ';
				} else {
					offices += profile.offices[i].name;
				}
			}
		} else if (profile.legacyOffice && profile.legacyOffice !== '') {
			offices = profile.legacyOffice;
		}

		//single.classList.add('contextual-menu__inner-list__profiles__profile--active');

		return (
			<li key={uid} className='contextual-menu__inner-list__profiles__profile'>
				<div className='contextual-menu__inner-list__profiles__profile__cell contextual-menu__inner-list__profiles__profile__picture span1 hide-tablet hide-mobile'>
					{(profile.logo && profile.logo.normal) && (
						<Link to={url} onClick={(event) => this.onLinkClick(event)}>
							<img {...profile.logo.normal} alt={profile.name} />
						</Link>
					)}
				</div>
				<div className='contextual-menu__inner-list__profiles__profile__cell contextual-menu__inner-list__profiles__profile__name span3-tablet span4 span10-mobile'>
					<Link to={url} className='contextual-menu__inner-list__profiles__profile__name__strong' onClick={(event) => this.onLinkClick(event)}>
						{profile.name}
						<span className='contextual-menu__inner-list__profiles__profile__name contextual-menu__inner-list__profiles__profile__name__weak'>{offices}</span>
					</Link>
				</div>
				<div className='contextual-menu__inner-list__profiles__profile__cell'>{profile.stats.total}</div>
				<div className='contextual-menu__inner-list__profiles__profile__cell hide-mobile'>{profile.stats.FOTD}</div>
				<div className='contextual-menu__inner-list__profiles__profile__cell hide-mobile'>{profile.stats.TCEA}</div>
				<div className='contextual-menu__inner-list__profiles__profile__cell hide-mobile'>{profile.stats.FOTM}</div>
				<div className='contextual-menu__inner-list__profiles__profile__cell hide-mobile'>{profile.stats.FOTY}</div>
				<div className='contextual-menu__inner-list__profiles__profile__cell hide-mobile'>{profile.stats.TCEAY}</div>
				<div className='contextual-menu__inner-list__profiles__profile__cell hide-mobile'>{profile.stats.PCA}</div>
				<div className='contextual-menu__inner-list__profiles__profile__cell hide-mobile contextual-menu__inner-list__profiles__profile__cell--no-border contextual-menu__inner-list__profiles__profile__cell--grey'>{profile.stats.MOTD}</div>
			</li>
		);
	}

	hasClass(element, cls) {
		return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
	}

	profilesFetch(href) {
		if (href) {
			let parameters = href;
			parameters = parameters.split('/');
			parameters = parameters[parameters.length - 1];

			parameters = parameters.split('&');

			let offset = parameters[0].split('=')[1];

			let limit = parameters[1].split('=')[1];

			let query = parameters[2].split('=')[1];

			// this.setState({
			// 	searched: true,
			// });

			this.offset = offset;
			this.limit = limit;
			this.query = query;

			this.fetchProfiles(offset, limit, query, this.order, this.orderBy);
		}
	}

	profilesPrev(e) {
		e.preventDefault();

		this.refs.profilesHolder.scrollTop = this.refs.profilesHolder.scrollTop - this.refs.profilesHolder.offsetHeight;
	}

	profilesNav(e) {
		e.preventDefault();

		let href = null;

		if (e.target.getAttribute('href')) {
			href = e.target.getAttribute('href');
		} else {
			href = e.target.parentNode.getAttribute('href');
		}

		this.refs.profilesHolder.scrollTop = this.refs.profilesHolder.lastChild.offsetHeight;

		this.profilesFetch(href);

		this.setState({
			active: false,
		});
	}

	sortClick(e) {

		let target = e.target;

		if (!this.hasClass(target, 'contextual-menu__inner-list__profiles__table__head__title')) {
			target = target.parentNode;

			if (target.tagName !== 'DIV') {
				target = target.parentNode;
			}
		}

		this.orderBy = target.getAttribute('data-sort');

		if (this.hasClass(target, 'contextual-menu__inner-list__profiles__table__head__title--sort')) {
			if (this.hasClass(target, 'contextual-menu__inner-list__profiles__table__head__title--sort--asc')) {
				this.order = '';
				target.classList.remove('contextual-menu__inner-list__profiles__table__head__title--sort--asc');
			} else {
				this.order = 'ASC';
				target.classList.add('contextual-menu__inner-list__profiles__table__head__title--sort--asc');
			}
		} else {
			if (document.querySelector('.contextual-menu__inner-list__profiles__table__head__title--sort')) {
				document.querySelector('.contextual-menu__inner-list__profiles__table__head__title--sort').classList.remove('contextual-menu__inner-list__profiles__table__head__title--sort');
			}

			if (document.querySelector('.contextual-menu__inner-list__profiles__table__head__title--sort--asc')) {
				document.querySelector('.contextual-menu__inner-list__profiles__table__head__title--sort--asc').classList.remove('contextual-menu__inner-list__profiles__table__head__title--sort--asc');
			}

			this.order = '';
			target.classList.add('contextual-menu__inner-list__profiles__table__head__title--sort');
		}

		this.setState({
			searched: true,
			clearProfiles: true,
		});

		this.refs.profilesHolder.scrollTop = 0;

		this.fetchProfiles(0, 36, this.query, this.order, this.orderBy);
	}

	onLinkClick(e) {
		document.querySelector('body').classList.remove('context-active');

		this.setState({
			active: false,
		});
	}

	onProfileSearch(e) {
		let string = e.target.value;

		let state = this.state.searched;
		let _this = this;

		clearTimeout(this.inputTimeout);

		this.refs.profilesHolder.scrollTop = 0;

		this.query = string;

		if (document.querySelector('.contextual-menu__inner-list__profiles__table__head__title--sort')) {
			document.querySelector('.contextual-menu__inner-list__profiles__table__head__title--sort').classList.remove('contextual-menu__inner-list__profiles__table__head__title--sort');
		}

		if (document.querySelector('.contextual-menu__inner-list__profiles__table__head__title--sort--asc')) {
			document.querySelector('.contextual-menu__inner-list__profiles__table__head__title--sort--asc').classList.remove('contextual-menu__inner-list__profiles__table__head__title--sort--asc');
		}

		this.inputTimeout = setTimeout(function() {
			_this.fetchProfiles(0, 36, string, '', '');
			_this.setState({
				searched: true,
				clearProfiles: true,
			});
		}, 400);
	}

	onClick(e) {
		e.preventDefault();
		document.querySelector('body').classList.toggle('context-active');

		try {
			localStorage.setItem('context', 'seen');
		} catch (e) {}

		this.setState({
			active: !this.state.active,
		});
	}
}

export default connect(ContextualProfiles);



/** WEBPACK FOOTER **
 ** ./frontend/components/contextual/contextualProfiles.js
 **/